import React from 'react';
import ReactMarkdown from 'react-markdown';
import { PolicyHeaderCard } from './PolicyAcceptanceModal';
import { usePolicyDocuments } from './usePolicyDocuments';
import type { PolicyPageDoc } from './policyPaths';
import './PolicyAcceptanceModal.scss';

interface PolicyDocumentPageProps {
  doc: PolicyPageDoc;
}

export default function PolicyDocumentPage({ doc }: PolicyDocumentPageProps) {
  const { privacy, eula, loading, error, retry } = usePolicyDocuments();
  const document = doc === 'privacy' ? privacy : eula;

  return (
    <div className="policy-page">
      <div className="policy-page__inner">
        {loading && (
          <div className="policy-modal__state" role="status" aria-live="polite">
            <div className="policy-modal__spinner" aria-hidden="true" />
            <p>Loading…</p>
          </div>
        )}

        {!loading && (error || !document) && (
          <div className="policy-modal__state policy-modal__state--error" role="alert">
            <p>We couldn't load this document. Please check your connection and try again.</p>
            <button type="button" className="policy-modal__retry-btn" onClick={retry}>
              Try again
            </button>
          </div>
        )}

        {!loading && document && (
          <>
            <PolicyHeaderCard header={document.header} />
            <article className="policy-modal__content">
              <ReactMarkdown>{document.content}</ReactMarkdown>
            </article>
          </>
        )}
      </div>
    </div>
  );
}
